import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick", "widgetLocation", "promptsHeight", "disableAnimation", "consentPromptEnabled"];
import styled from 'styled-components';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import { adjustLuminance } from 'visitor-ui-component-library/utils/adjustLuminance';
import { WHITE, OBSIDIAN } from 'visitor-ui-component-library/constants/WidgetColors';
import { useCustomerAgentHover } from '../contexts/CustomerAgentHoverContext';
import CloseIcon from './CloseIcon';
import { LEFT_ALIGNED, RIGHT_ALIGNED } from 'conversations-internal-schema/widget-location/constants/WidgetLocations';
import { useUserHasRecentlyGivenConsent } from './hooks/useUserHasRecentlyGivenConsent';
import { jsx as _jsx } from "react/jsx-runtime";
const BUTTON_ABOVE_PROMPTS_OFFSET = 6;
const getAnimationStyles = (promptsHeight, isHoverActive, disableAnimation = false, hasRecentlyGivenConsent = false) => {
  const animationHeight = promptsHeight ? promptsHeight + BUTTON_ABOVE_PROMPTS_OFFSET : 0;
  if (disableAnimation) {
    return {
      bottom: `${animationHeight}px`,
      transition: 'none'
    };
  }
  if (hasRecentlyGivenConsent && isHoverActive) {
    return {
      bottom: `${animationHeight}px`,
      transition: 'none'
    };
  }
  if (!isHoverActive) {
    return {
      bottom: '0px',
      transform: 'translateY(0px)'
    };
  }
  return {
    bottom: '0px',
    transform: `translateY(-${animationHeight}px)`
  };
};
const StyledIconButton = styled(VizExIconButton)(({
  widgetLocation,
  promptsHeight,
  isHoverActive,
  disableAnimation,
  hasRecentlyGivenConsent
}) => {
  return Object.assign({
    zIndex: 999,
    position: 'absolute',
    left: widgetLocation === LEFT_ALIGNED ? '0' : 'auto',
    right: widgetLocation === RIGHT_ALIGNED ? '0' : 'auto',
    height: '16px',
    width: '16px',
    borderRadius: '20px',
    backgroundColor: OBSIDIAN,
    color: OBSIDIAN,
    border: `1px solid ${OBSIDIAN}`,
    fontSize: '12px',
    '&:hover:enabled': {
      backgroundColor: adjustLuminance(OBSIDIAN, 10),
      borderColor: OBSIDIAN
    },
    '&:active:enabled': {
      backgroundColor: adjustLuminance(OBSIDIAN, -10),
      borderColor: OBSIDIAN
    },
    transition: disableAnimation ? 'none' : 'all .5s ease-in-out'
  }, getAnimationStyles(promptsHeight, isHoverActive, disableAnimation, hasRecentlyGivenConsent));
});
const CloseButton = _ref => {
  let {
      onClick,
      widgetLocation,
      promptsHeight = 0,
      disableAnimation = false,
      consentPromptEnabled = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isHoverActive
  } = useCustomerAgentHover();
  const hasRecentlyGivenConsent = useUserHasRecentlyGivenConsent(consentPromptEnabled, isHoverActive);
  return /*#__PURE__*/_jsx(StyledIconButton, Object.assign({
    shape: "circle",
    onClick: onClick,
    widgetLocation: widgetLocation,
    promptsHeight: promptsHeight,
    isHoverActive: isHoverActive,
    disableAnimation: disableAnimation,
    hasRecentlyGivenConsent: hasRecentlyGivenConsent
  }, rest, {
    children: /*#__PURE__*/_jsx(VizExIcon, {
      icon: /*#__PURE__*/_jsx(CloseIcon, {
        height: 8,
        width: 8,
        color: WHITE
      })
    })
  }));
};
CloseButton.displayName = 'VisitorWidgetCloseButton';
export default CloseButton;